import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  roundtrip: {
    width: 100,
    height: 100,
    paths: [
      {
        style: `fill: #eb212e`,
        d: `M97.41,87.7v3.39a.8.8,0,0,1-.8.8H3.51a.8.8,0,0,1-.81-.8V87.7a.81.81,0,0,1,.81-.81H4V48.28H27.87a26.78,
        26.78,0,0,0,20.69,12.3v4.86H22.41V49.81a.8.8,0,0,0-.8-.8H20.22a.8.8,0,0,0-.81.8V65.44H8.76a.81.81,0,0,
        0-.81.81v1.39a.8.8,0,0,0,.81.8H19.41V84.08a.8.8,0,0,0,.81.8h1.39a.8.8,0,0,0,.8-.8V68.44H48.56V84.08a.8.8,
        0,0,0,.8.8h1.39a.8.8,0,0,0,.81-.8V68.44H77.49V84.08a.8.8,0,0,0,.81.8h1.39a.8.8,0,0,0,.8-.8V68.44H90.93a.8.8,0,0,0,
        .81-.8V66.25a.81.81,0,0,0-.81-.81H80.49V49.81a.8.8,0,0,0-.8-.8H78.3a.8.8,0,0,0-.81.8V65.44H51.56V60.62A26.72,26.72,
        0,0,0,73,48.28H95.73V86.89h.88A.8.8,0,0,1,97.41,87.7Z`,
      },
      {
        style: `fill: #4d4d4d`,
        d: `M27.86,48.28H3.51a.81.81,0,0,1-.81-.81V44.08a.8.8,0,0,1,.81-.8H25.35A26.89,26.89,0,0,0,
        27.86,48.28Zm68.75-5H75.49a27.52,27.52,0,0,1-2.51,5H96.61a.8.8,0,0,0,.8-.81V44.08A.8.8,0,0,0,96.61,43.28Z`,
      },
      {
        style: `fill: #4d4d4d`,
        d: `M50.42,10.1A23.78,23.78,0,1,0,74.2,33.88,23.78,23.78,0,0,0,50.42,
          10.1ZM36.58,31.79a.8.8,0,0,1,.59-1.34h3.25c0-6,4.5-10.79,10-10.79A9.88,9.88,0,0,1,59,
          25a.3.3,0,0,1-.27.44H56.05a.58.58,0,0,1-.46-.22,6.65,6.65,0,0,0-5.17-2.57c-3.84,0-7,3.49-7,
          7.79h3.25a.8.8,0,0,1,.59,1.34L42.51,37a.79.79,0,0,1-1.18,0ZM63.67,37.3H60.35c0,6-4.49,10.86-10,10.86a9.89,
          9.89,0,0,1-8.62-5.35.32.32,0,0,1,.28-.45h2.7a.59.59,0,0,1,.46.23,6.72,6.72,0,0,0,5.18,2.57c3.86,0,
          7-3.53,7-7.86H54.17A.8.8,0,0,1,53.58,36l4.75-5.24a.79.79,0,0,1,1.18,0L64.26,36A.8.8,0,0,1,63.67,37.3Z`,
      },
    ],
  },
});
